module.exports = __webpack_public_path__ + "img/mine_orange.4f440dd1.png";